import Chevron from '~/icons/Chevron';
import { NavigationButton } from './TileCarousel.styles';

type OwnProps = {
  onClick: () => void;
};

export default function NextArrow({ onClick }: OwnProps) {
  return (
    <NavigationButton
      aria-label="previous slide"
      className="left-[30px]"
      onClick={onClick}
      data-analytics-id="Gallery - Swiped Right on Image Carousel"
      data-qa="gallery-back"
    >
      <Chevron reversed />
    </NavigationButton>
  );
}
